  <template>
  <div>
    <!-- app -->
    <div class="top-app" style="margin-top: 0" v-if="appShow && $store.state.appInfo.app_state == 1">
      <a id="appClose" class="app-close" @click="changappShow"></a>
      <!-- @click="$parent.downloadUrl($store.state.appInfo.ios_download_url)" -->
      <a id="appOpenDownload" :href="$store.state.appInfo.ios_download_url" class="app-download"></a>
    </div>
    <!-- h红包 -->
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/hongbao')" class="grab"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>
    <!-- 头部 -->
    <div class="header">
      <div class="header-left">
        <a @click="$parent.goNav('/app')" class="header-download"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo"> <img :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" /> </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a id="gocs_btn" @click="$parent.openKefu" class="header-helper"></a>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="home-banner" style="margin-top: 10px">
      <div class="banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
            <a> <img :src="item.src" alt="" /></a>
          </div>
        </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
      </div>
      <div class="pagination" style="bottom: -15px"></div>
    </div>
    <!-- 公告 -->
    <div class="notice mtb15 clearfix">
      <span> <img src="/static/image/icon_notice_tt.png" width="30" /> </span>
      <div class="marquee" style="flex: 1">
        <van-notice-bar color="#666" background="#fff" scrollable @click="openGogao(homenoticelis[0])" :text="textCont"> </van-notice-bar>
      </div>

      <a class="message pr" @click="$parent.goNav('/message')">
        <img src="/static/image/icon_notice_msg.png" width="25" />
      </a>
    </div>
    <!-- 登录后 显示用户操作 -->
    <div class="home-nav mb15" v-if="$store.state.token">
      <div class="account mb15 clearfix">
        <div class="profile">
          <div class="profile-image" style="width: 1.2rem; height: 1.2rem"><img style="width: 1.2rem; height: 1.2rem" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/profile.jpg'" /></div>
          <p style="font-size: 0.4rem">
            {{ $store.state.userInfo.username }}<span style="display: inline-block; margin-left: 16px">¥{{ $store.state.userInfo.balance }}</span>
          </p>
        </div>
      </div>
      <div class="wallet">
        <a id="godeposit_btn" @click="$parent.goNav('/recharge')" class="deposit"><i></i><span>存款</span></a>
        <a id="gowithdrawal_btn" @click="$parent.goNav('/withdrawal')" class="withdraw"><i></i><span>取款</span></a>
        <a id="gotransfer_btn" @click="$parent.goNav('/transfer')" class="transfer"><i></i><span>转账</span></a>
        <a id="gobetslip_btn" @click="$parent.goNav('/betRecord')" class="record"><i></i><span>注单</span></a>
      </div>
    </div>
    <!-- 未登录 -->
    <div class="home-nav mb15" v-if="!$store.state.token">
      <div class="wallet" @click="$parent.goNav('/login')">
        <a id="godeposit_btn" class="deposit"><i></i><span>存款</span></a>
        <a id="gowithdrawal_btn" class="withdraw"><i></i><span>取款</span></a>
        <a id="gotransfer_btn" class="transfer"><i></i><span>转账</span></a>
        <a id="gobetslip_btn" class="record"><i></i><span>注单</span></a>
      </div>
    </div>
    <!-- 游戏显示 -->
    <div class="home-platform mtb15">
      <ul class="platform-category">
        <li @click="changGameType(0)" :class="gameType == 0 ? 'active' : ''"><a id="sports_btn" href="javascript:void(0);">体育</a></li>
        <li @click="changGameType(1)" :class="gameType == 1 ? 'active' : ''"><a id="gaming_btn" href="javascript:void(0);">真人</a></li>
        <li @click="changGameType(2)" :class="gameType == 2 ? 'active' : ''"><a id="live_btn" href="javascript:void(0);">电竞</a></li>
        <li @click="changGameType(3)" :class="gameType == 3 ? 'active' : ''"><a id="lottery_btn" href="javascript:void(0);">棋牌</a></li>
        <li @click="changGameType(4)" :class="gameType == 4 ? 'active' : ''"><a id="chess_btn" href="javascript:void(0);">电子</a></li>
        <li @click="changGameType(5)" :class="gameType == 5 ? 'sr active' : 'sr'"><a id="egame_btn" href="javascript:void(0);">彩票</a></li>
      </ul>

      <div class="platform-wrap" id="gamelist" style="padding-bottom: 46px" v-if="$store.state.sportList.length > 0">
        <div class="platform-game platform-swiper swiper-container" v-show="gameType == 0">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(mun, int) in Math.ceil($store.state.sportList.length / 4)" :key="int">
              <a id="platform-aisport" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" href="javascript:void(0);" v-for="(item, index) in $store.state.sportList" v-if="index >= int * 4 && index < mun * 4" :key="index">
                <div class="d11-image-wrap"><img :src="`/static/image/sportPage/${item.platform_name}.png`"  /></div>
              </a>
            </div>
          </div>
          <div v-show="gameType == 0" class="swiper-pagination0 swiper-pagination"></div>
        </div>
        <div class="platform-game platform-swiper swiper-container" v-show="gameType == 1">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(mun, int) in Math.ceil($store.state.realbetList.length / 4)" :key="int">
              <a id="platform-aisport" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" href="javascript:void(0);" v-for="(item, index) in $store.state.realbetList" v-if="index >= int * 4 && index < mun * 4" :key="index">
                <div class="d11-image-wrap"><img :src="`/static/image/realbetPage/${item.platform_name}.png`" onerror="this.src='/static/image/realbetPage/cuo.png'" /></div>
                <!-- {{item.name}} -->
              </a>
            </div>
          </div>
          <div v-show="gameType == 1" class="swiper-pagination1 swiper-pagination"></div>
        </div>
        <div class="platform-game platform-swiper swiper-container" v-show="gameType == 2">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(mun, int) in Math.ceil($store.state.gamingList.length / 4)" :key="int">
              <a id="platform-aisport" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" href="javascript:void(0);" v-for="(item, index) in $store.state.gamingList" v-if="index >= int * 4 && index < mun * 4" :key="index">
                <div class="d11-image-wrap"><img :src="`/static/image/gamingPage/${item.platform_name}.png`" onerror="this.src='/static/image/gamingPage/cuo.png'" /></div>
              </a>
            </div>
          </div>
          <div v-show="gameType == 2" class="swiper-pagination2 swiper-pagination"></div>
        </div>
        <div class="platform-game platform-swiper swiper-container" v-show="gameType == 3">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(mun, int) in Math.ceil($store.state.jokerList.length / 4)" :key="int">
              <a id="platform-aisport" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" href="javascript:void(0);" v-for="(item, index) in $store.state.jokerList" v-if="index >= int * 4 && index < mun * 4" :key="index">
                <div class="d11-image-wrap"><img :src="`/static/image/jokerPage/${item.platform_name}.png`" onerror="this.src='/static/image/jokerPage/cuo.png'" /></div>
              </a>
            </div>
          </div>
          <div v-show="gameType == 3" class="swiper-pagination3 swiper-pagination"></div>
        </div>
        <div class="platform-game platform-swiper swiper-container" v-show="gameType == 4">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <a id="platform-aisport" @click="$parent.goNav('/concise?type=obgdy')" href="javascript:void(0);">
                <div class="d11-image-wrap"><img style="min-height: 3.7rem" src="/static/image/concisePage/obgdy.png" onerror="this.src='/static/image/concisePage/cuo.png'" /></div>
              </a>
              <a id="platform-aisport" @click="$parent.goNav('/concise?type=fgdz')" href="javascript:void(0);">
                <div class="d11-image-wrap"><img style="min-height: 3.7rem" src="/static/image/concisePage/fgdz.png" onerror="this.src='/static/image/concisePage/cuo.png'" /></div>
              </a>
              <a id="platform-aisport" @click="$parent.goNav('/concise?type=pp')" href="javascript:void(0);">
                <div class="d11-image-wrap"><img style="min-height: 3.7rem" src="/static/image/concisePage/pp.png" onerror="this.src='/static/image/concisePage/cuo.png'" /></div>
              </a>
              <a id="platform-aisport" @click="$parent.goNav('/concise?type=ae')" href="javascript:void(0);">
                <div class="d11-image-wrap"><img style="min-height: 3.7rem" src="/static/image/concisePage/ae.png" onerror="this.src='/static/image/concisePage/cuo.png'" /></div>
              </a>
            </div>
            <div class="swiper-slide" v-for="(mun, int) in Math.ceil($store.state.conciseList.length / 4)" :key="int">
              <a id="platform-aisport" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" href="javascript:void(0);" v-for="(item, index) in $store.state.conciseList" v-if="index >= int * 4 && index < mun * 4" :key="index">
                <div class="d11-image-wrap"><img style="min-height: 3.7rem" :src="`/static/image/concisePage/${item.platform_name}.png`" onerror="this.src='/static/image/concisePage/cuo.png'" /></div>
              </a>
            </div>
          </div>
          <div v-show="gameType == 4" class="swiper-pagination4 swiper-pagination"></div>
        </div>
        <div class="platform-game platform-swiper swiper-container" v-show="gameType == 5">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(mun, int) in Math.ceil($store.state.lotteryList.length / 4)" :key="int">
              <a id="platform-aisport" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" href="javascript:void(0);" v-for="(item, index) in $store.state.lotteryList" v-if="index >= int * 4 && index < mun * 4" :key="index">
                <div class="d11-image-wrap"><img :src="`/static/image/lotteryPage/${item.platform_name == 'ig' ? item.game_code : item.platform_name}.png`" onerror="this.src='/static/image/lotteryPage/cuo.png'" /></div>
              </a>
            </div>
          </div>
          <div v-show="gameType == 5" class="swiper-pagination5 swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 公告弹窗 -->
    <div class="popup popup-notice" style="display: block" v-if="goInfo">
      <div class="popup-wrap">
        <h2><i></i>公告<a href="javascript:void(0);" class="popup-close" @click="goInfo = null">关闭</a></h2>
        <div class="popup-content">
          <p id="homeNoticeList" v-html="goInfo"></p>
        </div>
        <div class="popup-footer">
          <a id="noticeAction" class="btn-grey" href="javascript:void(0);"> &nbsp;</a>
          <a @click="$parent.goNav('/message'), (goInfo = null)">查看更多</a>
        </div>
      </div>
      <div class="popup-mask" onclick="javascript:void(0);"></div>
    </div>
    <!-- 网页弹窗 -->
    <div class="popup popup-notice" style="display: block" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="popup-wrap">
        <h2><i></i>欢迎来到{{ $store.state.appInfo.title }}<a href="javascript:void(0);" class="popup-close" @click="changtanshow">关闭</a></h2>
        <div class="popup-content">
          <p id="homeNoticeList" v-html="$store.state.appInfo.webcontent"></p>
        </div>
        <div class="popup-footer">
          <a id="noticeAction" class="btn-grey" href="javascript:void(0);"> &nbsp;</a>
          <a @click="changtanshow">关闭</a>
        </div>
      </div>
      <div class="popup-mask" onclick="javascript:void(0);"></div>
    </div>
  </div>
</template>
  <script>
export default {
  name: 'index',
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: 0,
      tanshow: true,
      appshow: true,
      goInfo: null,
      textCont: '',
    };
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
  },
  methods: {
    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      this.gameType = type;
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();

      document.execCommand('copy');

      this.$parent.showTost(1, '复制成功！');
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
            that.$nextTick(() => {
              new Swiper('.banner-swiper', {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: -18,
                observer: true,
                observeParents: true,
                watchSlidesVisibility: true /*避免出现bug*/,
                loop: true,
                autoplay: {
                  delay: 8000,
                },
                pagination: {
                  el: '.pagination',
                  clickable: true,
                },
              });
            });
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          let textCont = '';
          res.data.forEach(element => {
            textCont += `${element}`;
          });
          that.textCont = textCont;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
  },
  mounted() {
    let that = this;
    if (that.$store.state.lotteryList.length > 0) {
      that.$nextTick(() => {
        $('.platform-swiper').each(function (index, element) {
          $(this).addClass('swiper-' + index);
          var swiper = new Swiper('.swiper-' + index, {
            observer: true,
            observeParents: true,
            watchSlidesVisibility: true /*避免出现bug*/,
            pagination: {
              el: '.swiper-pagination' + index,
            },
          });
        });
      });
    }
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  watch: {
    '$store.state.lotteryList': {
      handler: function (newVal, oldVal) {
        let that = this;
        if (newVal != oldVal) {
          that.$nextTick(() => {
            $('.platform-swiper').each(function (index, element) {
              $(this).addClass('swiper-' + index);
              var swiper = new Swiper('.swiper-' + index, {
                observer: true,
                observeParents: true,
                watchSlidesVisibility: true /*避免出现bug*/,
                pagination: {
                  el: '.swiper-pagination' + index,
                },
              });
            });
          });
        }
      },
    },
  },
};
</script>
  <style lang="scss" scoped>
.home-platform .platform-swiper .swiper-slide {
  height: auto;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue